import { render, staticRenderFns } from "./IlmoitusSisaltoRaporttiValmis.vue?vue&type=template&id=164782d0&"
import script from "./IlmoitusSisaltoRaporttiValmis.vue?vue&type=script&lang=js&"
export * from "./IlmoitusSisaltoRaporttiValmis.vue?vue&type=script&lang=js&"
import style0 from "./IlmoitusSisaltoRaporttiValmis.vue?vue&type=style&index=0&id=164782d0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164782d0')) {
      api.createRecord('164782d0', component.options)
    } else {
      api.reload('164782d0', component.options)
    }
    module.hot.accept("./IlmoitusSisaltoRaporttiValmis.vue?vue&type=template&id=164782d0&", function () {
      api.rerender('164782d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IlmoitusSisaltoRaporttiValmis.vue"
export default component.exports